import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "flex flex-wrap items-center gap-2.5 border-b border-amber-300 bg-amber-50 px-4 py-2 text-left text-[13px] text-amber-800 lg:px-8",
  role: "status",
  "data-testid": "affiliate-impersonation-banner"
}
const _hoisted_2 = {
  class: "h-4 w-4",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = { class: "text-textPrimary" }
const _hoisted_5 = {
  class: "h-4 w-4",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_6 = ["d"]

import { mdiArrowLeft, mdiEyeOutline } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateImpersonationBanner',
  props: {
    affiliateName: {}
  },
  emits: ["back"],
  setup(__props: any, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", { d: _unref(mdiEyeOutline) }, null, 8, _hoisted_3)
    ])),
    _createElementVNode("span", null, [
      _createTextVNode(" Você está vendo o portal como "),
      _createElementVNode("b", _hoisted_4, _toDisplayString(_ctx.affiliateName), 1),
      _createTextVNode(" · somente leitura · o que aparece aqui é exatamente o que os usuários do afiliado veem. ")
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "ml-auto inline-flex items-center gap-1.5 rounded border border-lightGray30 bg-white px-3 py-1.5 text-[13px] font-medium text-textPrimary",
      "data-testid": "affiliate-impersonation-back",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
    }, [
      (_openBlock(), _createElementBlock("svg", _hoisted_5, [
        _createElementVNode("path", { d: _unref(mdiArrowLeft) }, null, 8, _hoisted_6)
      ])),
      _createTextVNode(" Voltar para a Gestão ")
    ])
  ]))
}
}

})